<div class="content-container" *ngIf="ready">
    <h3>{{title}}</h3>

    <p [innerHTML]="content"></p>
</div>
